module.exports = __webpack_public_path__ + "static/media/1 - Create New.0539e328.png";